<template>
  <div class="search">
    <div class="main">
      <div class="tips">
        <img src="../../assets/warn.png" alt="" />
        <span> 请输入身份证、手机号、验证手机后查阅案件信息。</span>
      </div>
      <div class="title">民事调解查询</div>
    </div>
    <v-login
      :getCaptcha="currentSendSmsCode"
      :mpLogin="currentLogin"
      :detailPath="'/liangqing-detail'"
      :mpSource="'LIANG_QING_WE'"
    />
    <div class="footer">
      <div>良庆区人民法院：0771-3114042</div>
      <div class="mid">备案号:浙ICP备19038363号</div>
      <!-- <div class="mid">备案号:桂ICP备2024033312号</div>
      <div>技术支持:杭州天迹信息技术服务有限公司</div> -->
    </div>
  </div>
</template>

<script>
import login from "../../components/Login.vue";
import {
  currentSendSmsCode,
  currentLogin,
  currentScanRecord,
} from "../../services/api";
export default {
  name: "Home",
  components: { "v-login": login },
  data() {
    return {
      currentSendSmsCode: currentSendSmsCode,
      currentLogin: currentLogin,
    };
  },

  mounted() {
    console.log("query", this.$route.query);
    if (this.$route.query.clientId) {
      currentScanRecord({
        clientId: this.$route.query.clientId,
        mpSource: this.$route.query.type,
      }).then((res) => {
        if (res.success) {
          // this.settime();
        }
      });
    }
  },
  methods: {},
};
</script>
<style scoped lang="less">
@import "./index.less";
</style>
